import {
    FieldType,
    Field,
    ComparatorPickerBuilder,
    ComparatorPicker,
    ComparatorPickerType,
    ComparisonOperator,
} from "../vforms-model";
import { assign } from "lodash-es";
import { ComparisonExpression } from "../expression-settings/model";

export enum SelectionListOrientation {
    Horizontal = 0,
    Vertical = 1,
}

export class SelectionListOption {
    value: string;

    text: string;

    deleted = false;

    constructor(text: string, value: string) {
        this.value = value;
        this.text = text;
    }
}

export class SelectionList extends Field {
    placeholder: string;

    orientation: SelectionListOrientation;

    options: SelectionListOption[] = [];

    constructor(type: FieldType) {
        super(type);
        this.orientation = SelectionListOrientation.Vertical;
        this.createOption();
    }

    createOption() {
        const option = new SelectionListOption(null, `${this.options.length + 1}`);
        this.options.push(option);
        return option;
    }

    toJson() {
        const definition = super.toJson();
        assign(definition, {
            placeholder: this.placeholder,
            orientation: this.orientation,
            options: this.options,
        });
        return definition;
    }
}

export class SingleSelectionListPickerBuilder extends ComparatorPickerBuilder {
    build(comparisonExpression: ComparisonExpression): ComparatorPicker {
        if (
            comparisonExpression.operator === ComparisonOperator.NotEmpty ||
            comparisonExpression.operator === ComparisonOperator.Empty
        ) {
            return new ComparatorPicker(ComparatorPickerType.None);
        }

        let field = comparisonExpression.field as SelectionList;
        return new ComparatorPicker(ComparatorPickerType.Selection, field.options);
    }
}

export class MultipleSelectionListPickerBuilder extends ComparatorPickerBuilder {
    build(comparisonExpression: ComparisonExpression): ComparatorPicker {
        if (
            comparisonExpression.operator === ComparisonOperator.NotEmpty ||
            comparisonExpression.operator === ComparisonOperator.Empty
        ) {
            return new ComparatorPicker(ComparatorPickerType.None);
        }

        let field = comparisonExpression.field as SelectionList;
        return new ComparatorPicker(ComparatorPickerType.Selection, field.options);
    }
}
